import styled from 'styled-components'

const Wrapper = styled.div`
  list-style: none;
  padding: 0;
  margin-left: -40px;
  padding-left: 40px;
  /* This hack below is for positioning the
  scrollbar outside of the container */
  overflow: auto; /* overflow overlay isnt supported on Firefox, so give it a reasonable default value */
  overflow: overlay;
  margin-right: -20px;
  padding-right: 20px;
`

export { Wrapper }
